
































import { Component, Inject, Model, Prop, Vue, Watch, Provide } from "vue-property-decorator";
import AlienSymbol from '../components/AlienSymbol.vue';
import gsap, { Draggable, TweenLite } from 'gsap/all';
import Timer from '../components/Timer.vue';

@Component({
	components:{
		Timer,
		AlienSymbol,
	}
})
export default class Alien extends Vue {

	public objective:number[]= [1,6];
	public numbers:number[]= [0,1,2,3,4,5,6,7,8,9];
	public numbersUnlocked:boolean[]= [true, true, false, false, false, true, false, false, false, false];
	public n1:number|null = null;
	public n2:number|null = null;
	public n3:number|null = null;
	public step:number = 0;
	public complete:boolean = false
	public timerPaused:boolean = false

	public get rand():number { return Math.random(); }

	public get result():number[] {
		if(this.n1==null && this.n2==null && this.n3==null) return [];
		
		let n3 = this.n3 === null? 1 : this.n3;
		let v = (this.n1 + this.n2) * n3;
		let chunks = v.toString().split("");
		let res = [];
		for (let i = 0; i < chunks.length; i++) {
			res.push(parseInt(chunks[i]));
		}
		if(v < 10 && !this.numbersUnlocked[v]) {
			this.unlock(v);
		}
		return res;
	}

	public mounted():void {
		let slot1 = <HTMLDivElement>this.$refs.slot1;
		let slot2 = <HTMLDivElement>this.$refs.slot2;
		let slot3 = <HTMLDivElement>this.$refs.slot3;
		
		for (let i = 0; i < (<Vue[]>this.$refs.number).length; i++) {
			const element = this.$refs.number[i];
			let d:Draggable = Draggable.create(element.$el, {type:"x,y",
				onDragEnd: (e)=> {
					let hits:boolean = false;
					if(d.hitTest(slot1, "50%")) {
						hits = true;
						this.n1 = (<AlienSymbol>element).value;
						this.checkComplete();
					}else if(d.hitTest(slot2, "50%")) {
						hits = true;
						this.n2 = (<AlienSymbol>element).value;
						this.checkComplete();
					}else if(slot3 && d.hitTest(slot3, "50%")) {
						hits = true;
						this.n3 = (<AlienSymbol>element).value;
						this.checkComplete();
					}
					if(hits) {
						gsap.set(element.$el, {scale:0, x:0, y:0});
						gsap.to(element.$el, {duration:1, scale:1, ease:"elastic.out(1, .4)"});
					}else{
						gsap.to(element.$el, {duration:1, x:0, y:0, ease:"elastic.out(1, .4)"});
					}
				}
			})[0];
		}
	}

	public beforeDestroy():void {
		
	}

	public unlocked(v:number):boolean {
		if(this.step > 0) return true;
		return this.numbersUnlocked[v];
	}

	private checkComplete():void {
		if(this.step == 0) return;
		if(this.result[0] == this.objective[0] && this.result[1] == this.objective[1] && this.step == 1) {
			let targets = [this.$refs.target, this.$refs.result, this.$refs.objective];
			gsap.to(targets, {opacity:0, duration:1, onComplete:_=>{
				this.step ++;
				this.objective = [1,2,8];
				this.n1 = null;
				this.n2 = null;
				gsap.to(targets, {opacity:1, duration:1, delay:.25});
			}});
		}else
		if(this.result[0] == this.objective[0] && this.result[1] == this.objective[1] && this.result[2] == this.objective[2] && this.step == 2) {
			this.complete = true;
			this.timerPaused = true;
		}
	}

	public clearSlot(v):void {
		switch(v) {
			case 1:
				this.n1 = null;
				break;
			case 2:
				this.n2 = null;
				break;
			case 3:
				this.n3 = null;
				break;
		}
	}

	private async unlock(v):Promise<any> {
		this.numbersUnlocked[v] = true;
		setTimeout(_=>{
			this.n1 = null;
			this.n2 = null;
		}, 250);
		let complete = this.numbersUnlocked.length == 10;
		for (let i = 0; i < this.numbersUnlocked.length; i++) {
			if(this.numbersUnlocked[i] !== true) complete = false;
		}
		if(complete) this.nextStep();
		await this.$nextTick();
		gsap.from(this.$refs.number[v].$el, {scale:0, duration:1, ease:"elastic.out(1, .4)", delay:.25})
	}

	private async nextStep():Promise<void> {
		this.step ++;
		await this.$nextTick();
		
		gsap.set(this.$refs.objective, {opacity:0});
		gsap.to(this.$refs.objective, {opacity:1, duration:1});
	}

}
